export default __webpack_public_path__ + "static/media/ic_link_40.e61956ee.svg";